module.exports = __webpack_public_path__ + "static/img/question.d65bbfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/question.png
// module id = EQqe
// module chunks = 3